import Swiper from 'swiper';
import Navigation from "swiper/modules/navigation.mjs";
import Pagination from "swiper/modules/pagination.mjs";

const createSwiper = (selector, options) => {

    const defaults = {
        slidesPerView: "auto",
        modules: [Navigation, Pagination],
        watchOverflow: true,
        pagination: {
            el: selector + " .swiper-pagination",
            clickable: true,
        },
    }

    return new Swiper(selector, $.extend({}, defaults, options || {}));
}

export {createSwiper};
